export interface FormsAutocompleteGlobalMappingStartedActionType {
  type: '@forms/AUTOCOMPLETE_GLOBAL_MAPPING_STARTED';
}

export const autocompleteGlobalMappingStarted = (): FormsAutocompleteGlobalMappingStartedActionType => ({
  type: '@forms/AUTOCOMPLETE_GLOBAL_MAPPING_STARTED',
});
